import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { mapIcon, getTextColor } from './shared.js';

var _excluded = ["active", "counter", "selection"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var counterExisted = function counterExisted(counter) {
  return counter ? counter > 0 : false;
};
var getSelection = function getSelection(active, counter, selection) {
  if (active || counterExisted(counter)) return 'selected';
  return selection === 'selected' ? 'selected' : 'unselected';
};
var mapBaseChipProps = function mapBaseChipProps(props) {
  var active = props.active,
    counter = props.counter,
    selection = props.selection,
    rest = _objectWithoutProperties(props, _excluded);
  return _objectSpread({
    selection: getSelection(active, counter, selection)
  }, rest);
};
var mapLeadingIcon = function mapLeadingIcon(props) {
  var leadingIcon = props.leadingIcon,
    active = props.active,
    counter = props.counter,
    selection = props.selection;
  if (!leadingIcon) return undefined;
  if (getSelection(active, counter, selection) === 'selected' && counterExisted(counter)) return undefined;
  var iconProps = mapIcon(props, leadingIcon);
  return iconProps && _objectSpread(_objectSpread({}, iconProps), {}, {
    me: '8'
  });
};
var mapNotificationBadge = function mapNotificationBadge(props) {
  var active = props.active,
    counter = props.counter,
    selection = props.selection;
  if (getSelection(active, counter, selection) === 'unselected' || !counterExisted(counter)) return undefined;
  return {
    label: counter,
    color: 'product.primary',
    size: 's',
    me: '8'
  };
};
var mapLabel = function mapLabel(props) {
  var active = props.active,
    counter = props.counter,
    selection = props.selection,
    state = props.state;
  return {
    tag: 'span',
    variant: 'body-s',
    textAlign: 'start',
    lineClamp: 1,
    textColor: getTextColor(getSelection(active, counter, selection), state)
  };
};
var getDropdownSize = function getDropdownSize(size) {
  return size === 's' ? '12' : '14';
};
var mapDropdown = function mapDropdown(props) {
  var dropdown = props.dropdown,
    active = props.active,
    counter = props.counter,
    selection = props.selection,
    state = props.state,
    size = props.size;
  if (!dropdown) return undefined;
  return {
    id: 'fill.arrow.thin-dropdown',
    color: getTextColor(getSelection(active, counter, selection), state),
    size: getDropdownSize(size),
    ms: '8'
  };
};

export { getSelection, mapBaseChipProps, mapDropdown, mapLabel, mapLeadingIcon, mapNotificationBadge };
//# sourceMappingURL=FilterChip.mappers.js.map
